import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
	ButtonGroup,
	Button,
	Drawer,
	DrawerHeader,
	DrawerBody,
	RootContainer,
	Container,
	FlexRow,
	FlexColumn,
	TitleRow,
	Title,
	Search,
	CircularProgress,
	Table,
	TableHeader,
	TableHeaderRow,
	TableHeaderColumn,
	TableBody,
	TableRow,
	TableColumn,
	TablePagination,
	NotFound,
	Bold,
	RadioGroup,
} from '../../../../../Styles';
import { Sidebar, VerticalDivision, TitleSection, TitleColumn, TableContainer } from './styles';
import { BrowseIcon } from '../../../../../Styles';

import { fetchAutocompleteDentiraProducts, fetchDentiraProductCategories } from '../../../../../../actions/inventoryActionsV2';

const BrowseCatalogue = ({ hidePrimaryProducts, onSelect, onClose, ...props }) => {
	const [open, setOpen] = useState(false);
	const [loadingCategories, setLoadingCategories] = useState(false);
	const [categories, setCategories] = useState({});
	const [selectedCategory, setSelectedCategory] = useState('');
	const [loadingProducts, setLoadingProducts] = useState(false);
	const [dentiraProducts, setDentiraProducts] = useState([]);
	const [searchText, setSearchText] = useState('');
	const [pageNumber, setPageNumber] = useState(0);
	const [pageSize, setPageSize] = useState(10);
	const { products = [], totalResults: count = 0 } = dentiraProducts || {};

	const fetchCategories = async () => {
		let { fetchDentiraProductCategories } = props;
		setLoadingCategories(true);

		let categories = await fetchDentiraProductCategories(hidePrimaryProducts);

		setCategories(categories);

		if ('null' in categories) {
			setSelectedCategory('null');
		} else {
			setSelectedCategory(Object.keys(categories)?.[0] || '');
		}

		setPageNumber(0);
		setLoadingCategories(false);
	};

	const searchDentiraProducts = async () => {
		const { fetchAutocompleteDentiraProducts } = props;
		setLoadingProducts(true);

		let dentiraProducts = (await fetchAutocompleteDentiraProducts(selectedCategory, searchText, pageSize, pageNumber + 1, hidePrimaryProducts)) || [];

		setDentiraProducts(dentiraProducts);
		setLoadingProducts(false);
	};

	useEffect(() => {
		if (open) {
			fetchCategories();
		}
	}, [open]);

	useEffect(() => {
		if (open) {
			searchDentiraProducts();
		}
	}, [open, searchText, selectedCategory, pageNumber, pageSize]);

	useEffect(() => {
		if (open) {
			setPageNumber(0);
		}
	}, [open, searchText, selectedCategory, pageSize]);

	return (
		<>
			<Button
				outline
				primary
				onClick={(e) => {
					setOpen(true);
				}}
			>
				<BrowseIcon />
				Browse Catalogue
			</Button>

			<Drawer
				anchor='bottom'
				open={open}
				onClose={() => {
					setOpen(false);
					if (onClose) {
						onClose();
					}
				}}
			>
				<DrawerHeader>
					Dentira Products Catalogue
					<ButtonGroup alignRight>
						<Button
							outline
							secondary
							onClick={() => {
								setOpen(false);
							}}
						>
							Close
						</Button>
					</ButtonGroup>
				</DrawerHeader>

				<DrawerBody>
					<Container>
						<FlexRow>
							<Sidebar>
								<Bold>CATEGORIES</Bold>

								{loadingCategories ? (
									<CircularProgress showSpinner={true} />
								) : (
									<RadioGroup
										name={'category-select'}
										fullWidth={true}
										value={selectedCategory}
										options={[
											...(categories['null']
												? [
														{
															name: 'NONE',
															value: 'null',
															description: `${categories['null']} items`,
														},
												  ]
												: []),
											...Object.keys(categories)
												.map((key) =>
													key !== 'null'
														? {
																name: key.toUpperCase(),
																value: key,
																description: `${categories[key]} items`,
																disabled: false,
														  }
														: null
												)
												.filter((option) => option),
										]}
										onClick={(e) => {
											setSelectedCategory(e.target.value);
										}}
									/>
								)}
							</Sidebar>

							<VerticalDivision />

							<RootContainer>
								<TitleSection>
									<TitleRow responsive='1200px'>
										<TitleColumn>
											<FlexRow>
												<FlexColumn flex='auto'>
													<Title>{`${count || 0} Items`}</Title>
												</FlexColumn>

												<FlexColumn flex='auto'>
													<FlexRow align='flex-end'>
														<Search
															searchText={searchText}
															placeholder={'Search By Product ID'}
															enableDelayOnChange={true}
															searchOnChange={true}
															onSearchHandler={(value) => setSearchText(value)}
														/>
													</FlexRow>
												</FlexColumn>
											</FlexRow>
										</TitleColumn>
									</TitleRow>
								</TitleSection>

								<TableContainer>
									<Table>
										<TableHeader>
											<TableHeaderRow>
												<TableHeaderColumn
													width={'30%'}
													minWidth={'18rem'}
												>
													Product Name
												</TableHeaderColumn>

												<TableHeaderColumn
													width={'15%'}
													minWidth={'8rem'}
												>
													Product ID
												</TableHeaderColumn>

												<TableHeaderColumn
													width={'15%'}
													minWidth={'8rem'}
												>
													Type
												</TableHeaderColumn>

												<TableHeaderColumn
													width={'15%'}
													minWidth={'8rem'}
												>
													Category
												</TableHeaderColumn>

												<TableHeaderColumn
													width={'25%'}
													minWidth={'8rem'}
												>
													Description
												</TableHeaderColumn>

												<TableHeaderColumn
													alignRight
													minWidth='12rem'
													maxWidth='12rem'
												>
													Actions
												</TableHeaderColumn>
											</TableHeaderRow>
										</TableHeader>

										<TableBody>
											{loadingProducts ? (
												<TableRow key='loading'>
													<TableColumn colSpan={'100%'}>
														<CircularProgress showSpinner={true} />
													</TableColumn>
												</TableRow>
											) : true ? (
												products.map((item, index) => (
													<TableRow key={index}>
														<TableColumn>
															<FlexRow>{item?.name || '-'}</FlexRow>
														</TableColumn>

														<TableColumn>
															<FlexRow>{item?.item_id || '-'}</FlexRow>
														</TableColumn>

														<TableColumn>
															<FlexRow>{item?.add_on ? 'Add-On' : 'Primary'}</FlexRow>
														</TableColumn>

														<TableColumn>
															<FlexRow>{item?.category || '-'}</FlexRow>
														</TableColumn>

														<TableColumn>
															<FlexRow>{item?.description || '-'}</FlexRow>
														</TableColumn>

														<TableColumn alignRight>
															<FlexRow>
																<ButtonGroup alignRight>
																	<Button
																		outline
																		secondary
																		onClick={() => {
																			onSelect(item);
																			setOpen(false);
																		}}
																	>
																		Select
																	</Button>
																</ButtonGroup>
															</FlexRow>
														</TableColumn>
													</TableRow>
												))
											) : (
												<TableRow key='not-found'>
													<TableColumn colSpan={'100%'}>
														<NotFound lines={["Couldn't find any items"]} />
													</TableColumn>
												</TableRow>
											)}
										</TableBody>
									</Table>
								</TableContainer>

								<TablePagination
									component='div'
									count={count}
									page={pageNumber}
									onPageChange={(e, pageNumber) => {
										setPageNumber(parseInt(pageNumber, 10));
									}}
									rowsPerPage={pageSize}
									onRowsPerPageChange={(e) => {
										setPageNumber(0);
										setPageSize(parseInt(e.target.value, 10));
									}}
								/>
							</RootContainer>
						</FlexRow>
					</Container>
				</DrawerBody>
			</Drawer>
		</>
	);
};

const mapStateToProps = (state) => {
	return {};
};

const mapDispatch = {
	fetchDentiraProductCategories,
	fetchAutocompleteDentiraProducts,
};

export default withRouter(connect(mapStateToProps, mapDispatch)(BrowseCatalogue));
